import { format } from "date-fns";

type Props = {
  id: number;
  userName: string;
  createdDate: string;
  notes: string;
  deleteTheComment: (id: number) => void;
};

export default function AddComments({ id, userName, createdDate, notes, deleteTheComment }: Props) {

  return (
    <>
      <div key={id} className="w-full flex justify-between flex-row mt-2 border-b pb-2">
        <h6 className={`text-xs`}>{userName}</h6>
        <div className="w-1/2">
          <p className={`text-xs w-full break-words`}>{notes}</p>
        </div>
        <div className="flex gap-1.5 items-center ">
          <p className={`text-xs`}>
            {format(new Date(createdDate), "MM/dd/yyyy hh:mm a")}
          </p>
          <p className="text-xs text-center m-0">
            <span className={`material-symbols-outlined text-[20px] text-[#D92D20] hover:cursor-pointer`} onClick={() => deleteTheComment(id)}>
              delete
            </span>
          </p>
        </div>
      </div>
    </>
  );

}
